import { engineComponent } from "neo-common";
import { Style } from "./Style";
import { ComponentTypes } from "../../ComponentTypes";
import { BGParticleElementAttributes } from "../Graphics/BGParticleElement";
import { StageController } from "../../StageController";
// import {BGParticleElementAttributes} from "../../../CustomComponents/BGParticleElement";
//
@engineComponent(ComponentTypes.Style)
// TODO add comments
export class BGParticleStyle extends Style {
    // value in percentage for creating reserv in display list to pooling particles
    static ElementsReserve: number = 0.5;

    // names for zones
    static NodeImages: string = "Images";
    static NodeBehavior: string = "Behavior";
    static NodeName: string = "Name";

    // TODO possible memory leak
    node: Element;

    private _counts: Array<number>;
    private _count: number;
    private _scale: Array<Array<number>>;
    private _images: Array<string>;

    private _radius: number;
    private _connected: number;
    private _speedX: Array<Array<number>>;
    private _speedY: Array<Array<number>>;
    private _lineWidth: number;
    private _lineColor: any;
    private _lineAlpha: number;
    /**
     *  In percentage from 100% width and height
     **/
    private _connectionZoneWidth: Array<Array<number>>;
    private _connectionZoneHeight: Array<Array<number>>;

    constructor() {
        super();

        this._count = 0;
        this._counts = [];
        this._images = [];
        this._scale = [];
        this._radius = 200;
        this._connected = 0;
        this._speedX = [];
        this._speedY = [];
        this._lineWidth = 1;
        this._lineColor = 0x000000;
        this._lineAlpha = 1;
        this._connectionZoneHeight = [];
        this._connectionZoneWidth = [];
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element) {
        this.node = node;

        super.create(node);

        this.parseChildrenNodes(node);
    }

    private parseChildrenNodes(node: Element): void {
        let next: Element = node.firstElementChild;
        while (next != null) {
            switch (next.nodeName) {
                case BGParticleStyle.NodeImages:
                    this.initializeImages(next);
                    break;
                case BGParticleStyle.NodeBehavior:
                    this.initializeBehavior(next);
                    break;
                default:
                    if (DEBUG) {
                        this.log("WARNING unknown node in particle style " + next.nodeName);
                    }
            }
            next = next.nextElementSibling;
        }
    }

    get count(): number {
        return this._count;
    }

    get counts(): Array<number> {
        return this._counts;
    }

    get images(): Array<string> {
        return this._images;
    }

    get scale(): Array<Array<number>> {
        return this._scale;
    }

    get speedX(): Array<Array<number>> {
        return this._speedX;
    }

    get speedY(): Array<Array<number>> {
        return this._speedY;
    }

    get lineAlpha(): number {
        return this._lineAlpha;
    }

    get radius(): number {
        return this._radius;
    }

    get connected(): number {
        return this._connected;
    }

    get lineWidth(): number {
        return this._lineWidth;
    }

    get lineColor(): number {
        return this._lineColor;
    }

    get connectionZoneWidth(): Array<any> {
        return this._connectionZoneWidth;
    }

    get connectionZoneHeight(): Array<any> {
        return this._connectionZoneHeight;
    }

    private initializeImages(node: Element): void {
        if (node.hasAttribute(BGParticleElementAttributes.ATTR_FROM_FRAME)) {
            this._images = node.getAttribute(BGParticleElementAttributes.ATTR_FROM_FRAME).split(";");

            for (let i: number = 0; i < this._images.length; i++) {
                // TODO 0000
                this._images[i] = this._images[i] + "0000";
            }
        } else if (node.hasAttribute(BGParticleElementAttributes.ATTR_IMAGES)) {
            this._images = node.getAttribute(BGParticleElementAttributes.ATTR_IMAGES).split(";");
            // console.log(this._images)
        }

        if (node.hasAttribute(BGParticleElementAttributes.SCALE)) {
            let scales = node.getAttribute(BGParticleElementAttributes.SCALE).split("|");

            for (let i = 0; i < scales.length; i++) {
                this._scale.push(scales[i].split(";").map(Number));
            }
        }

        if (node.hasAttribute(BGParticleElementAttributes.ATTR_COUNTS)) {
            let counts = node.getAttribute(BGParticleElementAttributes.ATTR_COUNTS).split(";").map(Number);
            for (let i = 0; i < counts.length; i++) {
                if (i == 0) {
                    this._counts.push(counts[i]);
                } else {
                    this._counts.push(counts[i] + this._counts[i - 1]);
                }
            }
            this._count = this._counts[this._counts.length - 1];
        }
    }

    private initializeBehavior(node: Element): void {
        if (node.hasAttribute(BGParticleElementAttributes.SPEED_X)) {
            let speedX = node.getAttribute(BGParticleElementAttributes.SPEED_X).split("|");
            for (let i = 0; i < speedX.length; i++) {
                this._speedX.push(speedX[i].split(";").map(Number));
            }
        }

        if (node.hasAttribute(BGParticleElementAttributes.SPEED_Y)) {
            let speedY = node.getAttribute(BGParticleElementAttributes.SPEED_Y).split("|");
            for (let i = 0; i < speedY.length; i++) {
                this._speedY.push(speedY[i].split(";").map(Number));
            }
        }

        if (node.hasAttribute(BGParticleElementAttributes.RADIUS)) {
            this._radius = parseInt(node.getAttribute(BGParticleElementAttributes.RADIUS));
        }

        if (node.hasAttribute(BGParticleElementAttributes.CONNECTED)) {
            this._connected = parseInt(node.getAttribute(BGParticleElementAttributes.CONNECTED));
        }

        if (node.hasAttribute(BGParticleElementAttributes.LINE_ALPHA)) {
            this._lineAlpha = parseFloat(node.getAttribute(BGParticleElementAttributes.LINE_ALPHA));
        }

        if (node.hasAttribute(BGParticleElementAttributes.LINE_WIDTH)) {
            this._lineWidth = parseInt(node.getAttribute(BGParticleElementAttributes.LINE_WIDTH));
        }

        if (node.hasAttribute(BGParticleElementAttributes.LINE_COLOR)) {
            this._lineColor = parseInt(node.getAttribute(BGParticleElementAttributes.LINE_COLOR), 16);
        }

        if (node.hasAttribute(BGParticleElementAttributes.CONNECTION_ZONE_WIDTH)) {
            let zoneWidth = node.getAttribute(BGParticleElementAttributes.CONNECTION_ZONE_WIDTH).split("|");
            for (let i = 0; i < zoneWidth.length; i++) {
                let width = zoneWidth[i].split(";").map(function (width) {
                    return (parseFloat(width) / 100) * StageController.Width;
                });
                this._connectionZoneWidth.push(width);
            }
        }

        if (node.hasAttribute(BGParticleElementAttributes.CONNECTION_ZONE_HEIGHT)) {
            let zoneHeight = node.getAttribute(BGParticleElementAttributes.CONNECTION_ZONE_HEIGHT).split("|");
            for (let i = 0; i < zoneHeight.length; i++) {
                let height = zoneHeight[i].split(";").map(function (height) {
                    return (parseFloat(height) / 100) * StageController.Height;
                });
                this._connectionZoneHeight.push(height);
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Styles/BGParticleStyle.ts
 **/